import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '@/lib/auth';

export function LogoutPage(): JSX.Element {
  const navigate = useNavigate();
  useEffect(() => {
    void signOut().then(() => navigate('/login', { replace: true }));
  }, [navigate]);
  return (
    <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
      Déconnexion…
    </div>
  );
}
